import styled from 'styled-components';

import { IOcAppTheme } from '../../config/ocTheme';
import { overlayInteraction } from '../Shared/ButtonOverlay.styled';

export const Container = styled.div`
  overflow: unset;
  max-width: 100%;
  width: 100%;
  position: relative;
`;

export const CustomScrollBars = styled.div`
  position: relative;
  overflow: hidden;
  width: 100%;
  height: 100%;
`;

export const ScrollContainer = styled.div<{ $atStart: boolean }>`
  position: absolute;
  inset: 0;
  overflow-x: auto;
  overflow-y: hidden;
  margin-right: -15px;
  margin-left: ${({ $atStart }) => ($atStart ? '-8px' : '0')};
  scroll-behavior: smooth;

  &::-webkit-scrollbar {
    display: none;
  }
`;


export const SourceGrid = styled.div<{ $atStart: boolean }>`
  display: flex;
  justify-content: flex-start;
  align-items: stretch;
  padding-top: 16px;
  padding-left: ${({ $atStart }) => ($atStart ? '8px' : '0')};
  gap: 16px;

  &::after{
    content: '';
    flex: 0 0 1px;
  }
`;

export const SourceItem = styled.div`
  width: 285px;
  flex-shrink: 0;
  flex-grow: 0;
`;

export const ArrowButton = styled.button`
  ${overlayInteraction({ 
    isHighlighted: (theme) => (theme as IOcAppTheme).color.buttonBG 
      ? !!(theme as IOcAppTheme).color.highlightOnButtonBG 
      : !!(theme as IOcAppTheme).color.highlightOnChatPanelBG, 
    backgroundColor: (theme) => (theme as IOcAppTheme).color.buttonBG || theme.color.chatPanelBG })}

  /* Re-assert absolute positioning after helper for proper placement */
  position: absolute;
  bottom: calc(50% - 12px);
  z-index: 1;
  background: ${({ theme }) => (theme as IOcAppTheme).color.buttonBG || theme.color.chatPanelBG };
  border: none;
  border-radius: 50%;
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);

  svg {
    color: ${({ theme }) => (theme as IOcAppTheme).color.buttonText || theme.color.chatPanel };
  }
`;

export const LeftArrowButton = styled(ArrowButton)`
  left: 0;
`;

export const RightArrowButton = styled(ArrowButton)`
  right: 0;
`;

export const ArrowIcon = styled.svg`
  width: 16px;
  height: 16px;
  color: ${({ theme }) => theme.color.chatHeading};
`;

